import { defineComponent as _defineComponent } from 'vue'
import { onMounted, ref } from "vue";
import { useCompanyUsersStore } from "@/pinia/subcompanies/companyUsers";
import CompanyUsersListGrid from "@/components/company/CompanyUsersListGrid.vue";
import ActionButton from "@/components/lib/button/ActionButton.vue";
import Modal2Component from "@/components/modal/Modal2Component.vue";
import CreateCompanyUserForm, {
  FormStateModel,
} from "@/components/company/forms/CreateCompanyUserForm.vue";
import { showErrorMessage } from "@/services/ui/messages";
import CompanyUsersListGridFilter from "@/components/company/CompanyUsersListGridFilter.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'CompanyUsersList',
  props: {
    companyId: null
  },
  setup(__props: any) {

const props = __props as {
  companyId?: number;
}



const companyUsersStore = useCompanyUsersStore();

onMounted(async () => {
  await companyUsersStore.fetchUsers(props.companyId);
});

const createUserModalShow = ref(false);
const createUserFormRef = ref<typeof CreateCompanyUserForm>(null);
const createUserIsPending = ref(false);

function handleShowCreateUserModalClick() {
  createUserModalShow.value = true;
}

async function handleCreateUser() {
  createUserIsPending.value = true;

  try {
    if (!createUserFormRef.value) return;
    const data: FormStateModel = await (
      createUserFormRef.value as any
    ).getFormData();

    try {
      await companyUsersStore.createUser({
        ...data,
        ...(props.companyId !== null && { subcompanyId: props.companyId }),
      });
      createUserModalShow.value = false;
      await companyUsersStore.fetchUsers(companyUsersStore.company?.id);
    } catch (e) {
      console.log(e);
      (createUserFormRef.value as any).resetFormValidationState();

      if (e.status && e.status === 422) {
        showErrorMessage(
          "Указанный email или телефон уже зарегистрированы в системе."
        );
      } else {
        showErrorMessage(
          "При создании пользователя произошла ошибка. Проверьте данные и попробуйте снова."
        );
      }
    }
  } catch (e) {
    console.error(e);
  } finally {
    createUserIsPending.value = false;
  }
}

return { __sfc: true,props, companyUsersStore, createUserModalShow, createUserFormRef, createUserIsPending, handleShowCreateUserModalClick, handleCreateUser, CompanyUsersListGrid, ActionButton, Modal2Component, CreateCompanyUserForm, CompanyUsersListGridFilter }
}

})